module.exports = __webpack_public_path__ + "static/media/DaysWorked5_5.69f1443b.png";